module.exports = __webpack_public_path__ + "static/media/title_minigamea6e2fd3e6c5ed4f4d772bb24de946b76.webp";